(function () {


angular
        .module('genesis_app')
        .service('authService', authService);

    authService.$inject = ['$location', 'angularAuth0', '$timeout', '$rootScope', 'jwtHelper', '$cookies'];

    function authService($location, angularAuth0, $timeout, $rootScope, jwtHelper, $cookies) {

        var ctrl = this;

        function setLanguage (language) {
            ctrl.language = language;
        }

        function getUserID() {
            var userID = localStorage.getItem('user_id');
            return userID;
        }

        function handleAuthentication() {      

            var accessToken = localStorage.getItem('access_token');
            var isAuth = isAuthenticated(true);
            var idToken = localStorage.getItem('id_token');
            
            if (idToken) {
                var expDate = jwtHelper.getTokenExpirationDate(idToken);                
                //RENOVAR TICKET
                if (jwtHelper.isTokenExpired(idToken)) {                
                    logout();
                    return;
                }
            }           

            if (accessToken && isAuth) {
                getProfile(function (err, profile) {                    
                    setLoading(false);
                });               
            }
            else {
                angularAuth0.parseHash(function (err, authResult) {
                    setLoading(true);
                    if (authResult && authResult.accessToken && authResult.idToken) {                        
                        setSession(authResult);
                        //carrega profile
                        getProfile(function (err, profile) {
                            isAuthenticated(true);
                            setLoading(false);
                        });
                    } else if (err) {
                        setLoading(false);
                        $timeout(function () {
                            $location.path('Home');
                        });
                    }
                    else {
                        setLoading(false);
                    }
                });
            }
        }

        function setSession(authResult) {
            // Set the time that the Access Token will expire at
            var expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
            
            localStorage.setItem('access_token', authResult.accessToken);
            localStorage.setItem('id_token', authResult.idToken);
            localStorage.setItem('expires_at', expiresAt);
        }

        function logout() {
            setLoading(true);
            // Remove tokens and expiry time from localStorage
            
            localStorage.removeItem('access_token');
            localStorage.removeItem('id_token');
            localStorage.removeItem('expires_at');
            localStorage.removeItem('user_id');
            $cookies.remove('token');
            $cookies.remove('logged');
            $cookies.remove('company-id');
            var redirect = 'https://' + location.host + '/Home/';
            angularAuth0.logout(
                {
                    returnTo: redirect
                }
            );          
        }

        function setLoading(value) {
            ctrl.loading = value;
        }

        function isAuthenticated(showLog) {
            // Check whether the current time is past the 
            // Access Token's expiry time
            var userID = localStorage.getItem('user_id');
            if (!userID) {
                return false;
            }

            var idToken = localStorage.getItem('id_token');
            if (idToken) {
                var expiresAt = jwtHelper.getTokenExpirationDate(idToken);
                var curTime = new Date().getTime();
                var dateCur = new Date(curTime);
                var dateExpires;
                if (expiresAt) {
                    dateExpires = new Date(expiresAt);
                }
                return curTime < expiresAt;
            }
            else {
                return false;
            }
        }

        function login(database) {
            //console.log('authService.login ' + database + ' ' + ctrl.language);

            localStorage.setItem('company_id', database);
            //console.log('Auth0.login ' + ctrl.language);

            angularAuth0.authorize({
                ui_locales: ctrl.language
            });
        }

        function signup(invitationID, companyId, invitationEmail) {
            localStorage.setItem('company_id', companyId);
            $cookies.put('company-id', companyId);
            angularAuth0.authorize({
                login_hint: invitationEmail,
                ui_locales: ctrl.language
            });
        }

        function getProfile(cb) {
            
            var accessToken = localStorage.getItem('access_token');
            var userID = localStorage.getItem('user_id');

            
            if (!accessToken) {
                throw new Error('Access token must exist to fetch profile');
            }

            if (userID) {
                $timeout(function () {     
                    $rootScope.$broadcast('on_get_profile', userID);
                    cb();
                });
            }
            else {
                angularAuth0.client.userInfo(accessToken,
                    function (err, profile) {
                        if (profile) {
                            setUserProfile(profile);
                            $rootScope.$broadcast('on_get_profile', profile.email);
                        }
                        cb(err, profile);
                    },
                    function (error) {
                        setLoading(false);
                    }
                );
            }
        }

        function setUserProfile(profile) {
            ctrl.profile = profile;
            localStorage.setItem('user_id', profile.email);
        }

        function getCachedProfile() {
            return ctrl.profile;
        }

        return {
            setLanguage: setLanguage,
            getUserID: getUserID,
            getProfile: getProfile,
            getCachedProfile: getCachedProfile,
            handleAuthentication: handleAuthentication,
            logout: logout,
            isAuthenticated: isAuthenticated,
            setLoading: setLoading,
            login: login,
            signup: signup,
            isLoading: ctrl.loading
        };
    }
})();